import { render, staticRenderFns } from "./GlobalPromoTransactionReport.vue?vue&type=template&id=90d1dd42"
import script from "./GlobalPromoTransactionReport.vue?vue&type=script&lang=js"
export * from "./GlobalPromoTransactionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports